import { __extends } from "tslib";
import { Children, Component } from 'react';
import PropTypes from 'prop-types';
var ServicesProvider = /** @class */ (function (_super) {
    __extends(ServicesProvider, _super);
    function ServicesProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ServicesProvider.prototype.getChildContext = function () {
        var services = this.props.services;
        return {
            services: services(),
        };
    };
    ServicesProvider.prototype.render = function () {
        return Children.only(this.props.children);
    };
    return ServicesProvider;
}(Component));
ServicesProvider.propTypes = {
    services: PropTypes.func,
};
ServicesProvider.childContextTypes = {
    services: PropTypes.object,
};
export default ServicesProvider;
//# sourceMappingURL=ServicesProvider.js.map